import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-sub-add.png'


const _withScopeId = n => (_pushScopeId("data-v-6be6c192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 2 }
const _hoisted_2 = { class: "condition-box" }
const _hoisted_3 = { class: "operator" }
const _hoisted_4 = { class: "unit" }
const _hoisted_5 = { class: "operator" }
const _hoisted_6 = { class: "unit" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "condition-box" }
const _hoisted_11 = { class: "operator" }
const _hoisted_12 = { class: "unit" }
const _hoisted_13 = { class: "operator" }
const _hoisted_14 = { class: "unit" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = { class: "condition-box" }
const _hoisted_18 = { style: {"margin":"0 5px","color":"#303133"} }
const _hoisted_19 = { class: "operator" }
const _hoisted_20 = { class: "unit" }
const _hoisted_21 = { class: "operator" }
const _hoisted_22 = { class: "unit" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "ws_drawer_footer" }

import { ref, watch, computed, onMounted } from 'vue'
import type { FormInstance } from 'element-plus'
import {
  CODE_ENUM,
  WARNING_TYPE_ENUM,
  TACTICS_TIME_TYPE_ENUM,
  PRODUCT_TYPE,
  OPERATOR_TYPE,
  ALARM_SATISFY_TYPE,
  ALARM_LEVEL_TYPE,
  ALARM_MODE_TYPE,
  ALARM_TIME_TYPE,
} from '@/common'
import { ElMessage } from 'element-plus'
import { useWarningStore } from '@/stores/warning'
import {
  queryLocusAoiAll,
  alarmStrategyAdd,
  alarmStrategyUpdate,
  alarmStrategyDetail,
  queryDeviceInfoByGatewayDeviceId,
  queryProductThingModelMetadata,
} from '@/api'
import moment from 'moment'
import { isEmpty } from 'lodash'
import i18n from '@/i18n'
import { useDeviceStore } from '@/stores/device'


export default /*#__PURE__*/_defineComponent({
  __name: 'config-form-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t

const warningStore = useWarningStore()

const deviceStore = useDeviceStore()

warningStore.getTriggerType()
warningStore.getSensorType()

const showIncrease = computed(() => {
  return form.value.sensors?.length <= 30
})

const operatorList: any = [
  {
    value: OPERATOR_TYPE.GREATER,
    label: t('W_TACTICS.operator1'),
    unit: '>',
  },
  {
    value: OPERATOR_TYPE.LESS,
    label: t('W_TACTICS.operator2'),
    unit: '<',
  },
  {
    value: OPERATOR_TYPE.EQUAL,
    label: t('W_TACTICS.operator3'),
    unit: '=',
  },
  {
    value: OPERATOR_TYPE.GREATER_EQUAL,
    label: t('W_TACTICS.operator4'),
    unit: '≥',
  },
  {
    value: OPERATOR_TYPE.LESS_EQUAL,
    label: t('W_TACTICS.operator5'),
    unit: '≤',
  },
  {
    value: OPERATOR_TYPE.GREATER_EQUAL_AND_LESS_EQUAL,
    label: t('W_TACTICS.operator6'),
    unit: '≥',
    unit2: '≤',
  },
]

// 等级告警
const levelOps = [
  {
    label: t('W_TACTICS.main'),
    value: ALARM_LEVEL_TYPE.ALARM_MAIN,
  },
  {
    label: t('W_TACTICS.minor'),
    value: ALARM_LEVEL_TYPE.ALARM_MINOR,
  },
  {
    label: t('W_TACTICS.urgency'),
    value: ALARM_LEVEL_TYPE.ALARM_URGENCY,
  },
  {
    label: t('W_TACTICS.warn'),
    value: ALARM_LEVEL_TYPE.ALARM_WARN,
  },
  // {
  //   label: t('W_TACTICS.clean'),
  //   value: ALARM_LEVEL_TYPE.ALARM_CLEAN,
  // },
]

const modeOps = [
  {
    label: t('W_TACTICS.simple'),
    value: ALARM_MODE_TYPE.SIMPLE,
  },
  {
    label: t('W_TACTICS.duringTime'),
    value: ALARM_MODE_TYPE.DURING_TIME,
  },
  {
    label: t('W_TACTICS.duringNum'),
    value: ALARM_MODE_TYPE.DURING_NUM,
  },
]

const timeOps = [
  {
    label: t('W_TACTICS.time1'),
    value: ALARM_TIME_TYPE.SECOND,
  },
  {
    label: t('W_TACTICS.time2'),
    value: ALARM_TIME_TYPE.MINUTE,
  },
  {
    label: t('W_TACTICS.time3'),
    value: ALARM_TIME_TYPE.HOUR,
  },
  {
    label: t('W_TACTICS.time4'),
    value: ALARM_TIME_TYPE.DAY,
  },
]

// 是否展示第二个条件
const showSecondThreshold = (operatorTypeCode: string) => {
  return operatorTypeCode === OPERATOR_TYPE.GREATER_EQUAL_AND_LESS_EQUAL
}

// 获取运算符
const getOperator = (operatorTypeCode: string, key: string) => {
  return (
    operatorList.filter((item: any) => {
      return item.value === operatorTypeCode
    })?.[0]?.[key] || ''
  )
}




const formRef: any = ref<FormInstance>()

const form: any = ref({
  name: '',
  deviceId: '',
  triggerTypeCode: '',
  aoiIds: [],
  conditionCode: '',
  sensors: [
    {
      deviceId: '',
      operatorTypeCode: '',
      sensorAttrCode: '',
      subDeviceId: '',
      thresholdStart: undefined,
      thresholdEnd: undefined,
      conditionDuringUnitCode: ALARM_TIME_TYPE.SECOND,
      conditionDuring: undefined,
    },
  ],
  conditionCode2: '',
  sensors2: [
    {
      operatorTypeCode: '',
      sensorAttrCode: '',
      subDeviceId: '',
      thresholdStart: undefined,
      thresholdEnd: undefined,
    },
  ],
})

const title = computed(() => {
  return props.data?.id ? t('W_TACTICS.editTitle') : t('W_TACTICS.newTitle')
})

// 清除掉多余的数据
watch(
  () => form.value.triggerTypeCode,
  (triggerTypeCode: string) => {
    if (triggerTypeCode === WARNING_TYPE_ENUM.AOI) {
      formRef.value.resetFields([
        'deviceId',
        'subDeviceId',
        'sensorAttrCode',
        'operatorTypeCode',
        'threshold',
      ])
    } else {
      formRef.value.resetFields(['aoiIds'])
    }
  }
)

const rules: any = ref({
  name: [
    { required: true, message: t('W_TACTICS.enterMsg'), trigger: 'change' },
  ],
  deviceId: [
    { required: true, message: t('W_TACTICS.selectMsg'), trigger: 'change' },
  ],
  triggerTypeCode: [
    { required: true, message: t('W_TACTICS.selectMsg'), trigger: 'change' },
  ],
  time: [
    { required: true, message: t('W_TACTICS.selectMsg'), trigger: 'change' },
  ],
  aoiIds: [
    { required: true, message: t('W_TACTICS.selectMsg'), trigger: 'change' },
  ],
  conditionCode: [
    { required: true, message: t('W_TACTICS.selectMsg'), trigger: 'change' },
  ],
  conditionCode2: [
    { required: true, message: t('W_TACTICS.selectMsg'), trigger: 'change' },
  ],
  alarmLevelCode: [
    { required: true, message: t('W_TACTICS.select'), trigger: 'change' },
  ],
})

watch(
  props,
  () => {
    if (props.visible) {
      queryBaseInfo()
    }
  },
  {
    deep: true,
  }
)
const loading = ref(false)
const queryBaseInfo = async () => {
  loading.value = true
  await Promise.all([
    queryAoiList(),
    queryDetail(),
    deviceStore.queryDeviceOps(),
  ])

  if (!props.data?.id) {
    loading.value = false
    return
  }
  const { sensors, sensors2, triggerTypeCode, deviceId } = form.value
  if (
    ![WARNING_TYPE_ENUM.SENSOR, WARNING_TYPE_ENUM.SENSORINCRE].includes(
      triggerTypeCode
    )
  ) {
    loading.value = false
    return
  }

  const baseRequest = isLora(deviceId)
    ? [queryDeviceVar(deviceId)]
    : [queryDeviceChildren(deviceId)]

  const totalSensors = sensors.concat(sensors2 || [])
  // fuck shabi
  const totalRequest = totalSensors.reduce((mo: any, { subDeviceId }: any) => {
    if (!subDeviceId) {
      return mo
    }
    mo.push(queryDeviceVar(subDeviceId))
    return mo
  }, baseRequest)
  await Promise.all(totalRequest)

  loading.value = false
}

// 判断选择的是否为lora   傻逼行为
const isLora = (deviceId: string) => {
  return (
    deviceStore.deviceOps.filter((item: any) => {
      return item.value === deviceId
    })?.[0]?.productTypeCode === PRODUCT_TYPE.LORA
  )
}

const getUnit = (subDeviceId: string, sensorAttrCode: string) => {
  const unitList = varList.value[subDeviceId] || []
  return (
    unitList.filter((item: any) => {
      return item.value === sensorAttrCode
    })?.[0]?.unit || ''
  )
}

const delSensorsData = (sensors: any) => {
  return sensors
    ? sensors
    : [
        {
          operatorTypeCode: '',
          sensorAttrCode: '',
          subDeviceId: '',
          thresholdStart: undefined,
          thresholdEnd: undefined,
          conditionDuringUnitCode: ALARM_TIME_TYPE.SECOND,
          conditionDuring: undefined,
        },
      ]
}

const queryDetail = async () => {
  if (!props.data?.id) {
    return
  }
  const res: any = await alarmStrategyDetail({
    alarmStrategyId: props.data?.id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const mo = res?.data || {}
    const {
      aoiInfos,
      name,
      triggerTypeCode,
      sensorInfo,
      sensorIncreAlarmInfo,
      alarmLevelCode,
      deviceId,
    } = mo

    const aoiIds = (aoiInfos || []).map((item: any) => item.aoiId)
    const { conditionCode } = sensorInfo || {}

    const result = {
      ...form.value,
      deviceId,
      aoiIds,
      name,
      triggerTypeCode,
      conditionCode,
      alarmLevelCode,
      sensors: delSensorsData(sensorInfo?.sensors || []),
      sensors2: delSensorsData(sensorIncreAlarmInfo?.sensors || []),
      conditionCode2: sensorIncreAlarmInfo?.conditionCode || '',
    }
    console.log(result, 'resultresultresult')
    form.value = result
  }
}

const submitLoading = ref(false)
const submit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      submitLoading.value = true
      const fn = props.data?.id ? alarmStrategyUpdate : alarmStrategyAdd

      const {
        name,
        triggerTypeCode,
        aoiIds,
        deviceId,
        conditionCode,
        alarmLevelCode,
        sensors,
        conditionCode2,
        sensors2,
      } = form.value

      // 傻逼
      const alarmStrategyAddSensorParam = {
        conditionCode,
        sensors,
      }

      const alarmStrategyAddSensorAlarmParam = {
        conditionCode: conditionCode2,
        sensors: sensors2,
      }
      const res: any = await fn({
        name,
        triggerTypeCode,
        aoiIds,
        deviceId,
        alarmLevelCode,
        triggerId: props.data?.id,
        // ...form.value.effective,
        alarmStrategyAddSensorParam,
        alarmStrategyAddSensorAlarmParam,
      }).finally(() => {
        submitLoading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        $emit('on-success')
        cancel()

        ElMessage.success(
          props.data?.id
            ? t('W_TACTICS.editSuccess')
            : t('W_TACTICS.newSuccess')
        )
      }
    }
  })
}

const cancel = () => {
  $emit('update:visible', false)
  form.value = {
    deviceId: '',
    name: '',
    triggerTypeCode: '',
    aoiIds: [],
    conditionCode: '',
    sensors: [
      {
        operatorTypeCode: '',
        sensorAttrCode: '',
        subDeviceId: '',
        thresholdStart: undefined,
        thresholdEnd: undefined,
        conditionDuringUnitCode: ALARM_TIME_TYPE.SECOND,
        conditionDuring: undefined,
      },
    ],
    conditionCode2: '',
    sensors2: [
      {
        operatorTypeCode: '',
        sensorAttrCode: '',
        subDeviceId: '',
        thresholdStart: undefined,
        thresholdEnd: undefined,
        conditionDuringUnitCode: ALARM_TIME_TYPE.SECOND,
        conditionDuring: undefined,
      },
    ],
  }
  formRef.value.resetFields()
}

const aoiList: any = ref([])
const queryAoiList = async () => {
  const res: any = await queryLocusAoiAll()
  aoiList.value = (res?.data || []).map(({ aoiName, id }: any) => {
    return {
      label: aoiName,
      value: id,
    }
  })
}

const beforeClose = () => {
  $emit('update:visible', false)
  cancel()
}

const onDeviceChange = (value: string) => {
  console.log(value, value)
  if (value && isLora(value)) {
    queryDeviceVar(value)
  } else {
    queryDeviceChildren(value)
  }

  form.value.sensors = form.value.sensors.map((item: any) => {
    return {
      ...item,
      subDeviceId: '',
      sensorAttrCode: '',
    }
  })
  form.value.sensors2 = form.value.sensors2.map((item: any) => {
    return {
      ...item,
      subDeviceId: '',
      sensorAttrCode: '',
    }
  })
}

const onDeviceChildrenChange = (key: string, value: string, index: number) => {
  queryDeviceVar(value)
  form.value[key][index].sensorAttrCode = ''
}

// 换一种map形式
const deviceChildren: any = ref({})
const getDiviceChildren = (deviceId: string) => {
  return deviceChildren.value[deviceId]
}
const queryDeviceChildren = async (gatewayDeviceId: string) => {
  if (!isEmpty(deviceChildren.value[gatewayDeviceId])) {
    return
  }
  const res: any = await queryDeviceInfoByGatewayDeviceId({
    gatewayDeviceId,
  })
  deviceChildren.value[gatewayDeviceId] = (res.data || []).map((item: any) => {
    return {
      label: item.deviceName,
      value: item.deviceId,
    }
  })
}

const varList: any = ref({})
const getVarList = (subDeviceId: string) => {
  return varList.value[subDeviceId]
}
const queryDeviceVar = async (subDeviceId: string) => {
  if (!isEmpty(varList.value[subDeviceId])) {
    return
  }
  const res: any = await queryProductThingModelMetadata({ subDeviceId })
  varList.value[subDeviceId] = (res.data || []).map((item: any) => {
    const { name, code, ...p } = item
    return {
      label: name,
      value: code,
      ...p,
    }
  })
}

const increase = (key: string) => {
  form.value[key].push({
    operatorTypeCode: '',
    sensorAttrCode: '',
    subDeviceId: '',
    thresholdStart: undefined,
    thresholdEnd: undefined,
    conditionDuringUnitCode: ALARM_TIME_TYPE.SECOND,
    conditionDuring: undefined,
  })
}

const reduce = (key: string, i: number) => {
  form.value[key] = form.value[key].filter(
    (item: any, index: number) => index !== i
  )
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_drawer, {
      "model-value": props.visible,
      title: _unref(title),
      size: "1100px",
      "before-close": beforeClose,
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_25, [
          _createVNode(_component_el_button, {
            loading: submitLoading.value,
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('W_TACTICS.btnOk')), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            plain: "",
            onClick: cancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('W_TACTICS.btnCancel')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          "label-width": "80px",
          rules: rules.value,
          class: "form",
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('W_TACTICS.labelNameForm'),
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "50",
                  placeholder: _ctx.$t('W_TACTICS.labelNamePla'),
                  style: {"width":"355px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('W_TACTICS.labelTypeName'),
              prop: "triggerTypeCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.value.triggerTypeCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.triggerTypeCode) = $event)),
                  class: "ws_select_form",
                  style: {"width":"355px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(warningStore).triggerType, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (form.value.triggerTypeCode === _unref(WARNING_TYPE_ENUM).AOI)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _ctx.$t('W_TACTICS.labelAoiForm'),
                  prop: "aoiIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: form.value.aoiIds,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.aoiIds) = $event)),
                      class: "ws_select_form",
                      multiple: "",
                      style: {"width":"355px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aoiList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (
            [_unref(WARNING_TYPE_ENUM).SENSOR, _unref(WARNING_TYPE_ENUM).SENSORINCRE].includes(
              form.value.triggerTypeCode
            )
          )
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _ctx.$t('W_TACTICS.deviceName'),
                  prop: "deviceId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: form.value.deviceId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.deviceId) = $event)),
                      class: "ws_select_form",
                      style: {"width":"355px"},
                      onChange: onDeviceChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceStore).deviceOps, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (form.value.triggerTypeCode === _unref(WARNING_TYPE_ENUM).SENSOR)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('W_TACTICS.condition'),
                      prop: "conditionCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.conditionCode,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.conditionCode) = $event)),
                          class: "ws_select_form",
                          style: {"width":"345px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: _unref(ALARM_SATISFY_TYPE).SATISFY_ALL,
                              label: _ctx.$t('W_TACTICS.conditionAll')
                            }, null, 8, ["value", "label"]),
                            _createVNode(_component_el_option, {
                              value: _unref(ALARM_SATISFY_TYPE).SATISFY_ONE,
                              label: _ctx.$t('W_TACTICS.conditionOne')
                            }, null, 8, ["value", "label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          class: "sensors-form-item",
                          prop: "sensors",
                          "label-width": 1,
                          rules: [
                  {
                    required: true,
                    message: _ctx.$t('W_TACTICS.sensorsMsg'),
                    trigger: 'change',
                    type: 'array',
                  },
                ]
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.sensors, (domain, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "bg",
                                key: index
                              }, [
                                _createVNode(_component_el_form_item, {
                                  "label-width": "5",
                                  prop: 'sensors.' + index + '.conditionDuringTypeCode',
                                  rules: [
                      {
                        required: true,
                        message: _ctx.$t('W_TACTICS.selectMsg'),
                        trigger: 'change',
                      },
                    ]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: domain.conditionDuringTypeCode,
                                      "onUpdate:modelValue": ($event: any) => ((domain.conditionDuringTypeCode) = $event),
                                      class: "select_item",
                                      placeholder: _ctx.$t('W_TACTICS.mode'),
                                      clearable: ""
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(modeOps, (item) => {
                                          return _createVNode(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"])
                                        }), 64))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                  ]),
                                  _: 2
                                }, 1032, ["prop", "rules"]),
                                _createVNode(_component_el_form_item, {
                                  prop: 'sensors.' + index + '.deviceId',
                                  "label-width": 1
                                }, {
                                  default: _withCtx(() => [
                                    (!isLora(form.value.deviceId))
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          "label-width": "5",
                                          prop: 'sensors.' + index + '.subDeviceId',
                                          rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.selectMsg'),
                          trigger: 'change',
                        },
                      ]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: domain.subDeviceId,
                                              "onUpdate:modelValue": ($event: any) => ((domain.subDeviceId) = $event),
                                              class: "select_item",
                                              placeholder: _ctx.$t('W_TACTICS.subDevicePla'),
                                              onChange: 
                          (e) => onDeviceChildrenChange('sensors', e, index)
                        
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDiviceChildren(form.value.deviceId), (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.value,
                                                    label: item.label,
                                                    value: item.value
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop", "rules"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "5",
                                      prop: 'sensors.' + index + '.sensorAttrCode',
                                      rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.selectMsg'),
                          trigger: 'change',
                        },
                      ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: domain.sensorAttrCode,
                                          "onUpdate:modelValue": ($event: any) => ((domain.sensorAttrCode) = $event),
                                          class: "select_item",
                                          placeholder: _ctx.$t('W_TACTICS.varPla')
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVarList(
                            isLora(form.value.deviceId)
                              ? form.value.deviceId
                              : domain.subDeviceId
                          ), (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "5",
                                      prop: 'sensors.' + index + '.operatorTypeCode',
                                      rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.selectMsg'),
                          trigger: 'change',
                        },
                      ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: domain.operatorTypeCode,
                                          "onUpdate:modelValue": ($event: any) => ((domain.operatorTypeCode) = $event),
                                          class: "select_item",
                                          placeholder: _ctx.$t('W_TACTICS.range')
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(operatorList, (item) => {
                                              return _createVNode(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"])
                                            }), 64))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "5",
                                      prop: 'sensors.' + index + '.thresholdStart',
                                      class: "operation-form",
                                      rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                        },
                        {
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                          type: 'number',
                        },
                      ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(getOperator(domain.operatorTypeCode, 'unit')), 1),
                                        _createVNode(_component_el_input_number, {
                                          class: "select_value input-number",
                                          modelValue: domain.thresholdStart,
                                          "onUpdate:modelValue": ($event: any) => ((domain.thresholdStart) = $event),
                                          placeholder: _ctx.$t('W_TACTICS.thresholdPla'),
                                          precision: 2,
                                          controls: false
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(getUnit(
                          isLora(form.value.deviceId)
                            ? form.value.deviceId
                            : domain.subDeviceId,
                          domain.sensorAttrCode
                        )), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    (showSecondThreshold(domain.operatorTypeCode))
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 1,
                                          "label-width": "5",
                                          prop: 'sensors.' + index + '.thresholdEnd',
                                          class: "operation-form",
                                          rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                        },
                        {
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                          type: 'number',
                        },
                      ]
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_5, _toDisplayString(getOperator(domain.operatorTypeCode, 'unit2')), 1),
                                            _createVNode(_component_el_input_number, {
                                              class: "select_value input-number",
                                              modelValue: domain.thresholdEnd,
                                              "onUpdate:modelValue": ($event: any) => ((domain.thresholdEnd) = $event),
                                              modelModifiers: { number: true },
                                              placeholder: _ctx.$t('W_TACTICS.thresholdPla'),
                                              precision: 2,
                                              controls: false
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                            _createElementVNode("span", _hoisted_6, _toDisplayString(getUnit(
                          isLora(form.value.deviceId)
                            ? form.value.deviceId
                            : domain.subDeviceId,
                          domain.sensorAttrCode
                        )), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["prop", "rules"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["prop"]),
                                (
                      domain.conditionDuringTypeCode ===
                      _unref(ALARM_MODE_TYPE).DURING_TIME
                    )
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      "label-width": "5",
                                      prop: 'sensors.' + index + '.conditionDuring',
                                      rules: [
                      {
                        required: true,
                        message: _ctx.$t('W_TACTICS.selectMsg'),
                        trigger: 'change',
                      },
                    ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input_number, {
                                          placeholder: _ctx.$t('W_TACTICS.keepTime'),
                                          modelValue: domain.conditionDuring,
                                          "onUpdate:modelValue": ($event: any) => ((domain.conditionDuring) = $event),
                                          "controls-position": "right",
                                          precision: 0,
                                          min: 1,
                                          style: {"width":"120px"}
                                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]))
                                  : _createCommentVNode("", true),
                                (
                      domain.conditionDuringTypeCode ===
                      _unref(ALARM_MODE_TYPE).DURING_TIME
                    )
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      "label-width": "5",
                                      prop: 'sensors.' + index + '.conditionDuringUnitCode'
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: domain.conditionDuringUnitCode,
                                          "onUpdate:modelValue": ($event: any) => ((domain.conditionDuringUnitCode) = $event),
                                          class: "select-unit"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeOps, (item) => {
                                              return _createVNode(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"])
                                            }), 64))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"]))
                                  : _createCommentVNode("", true),
                                (
                      domain.conditionDuringTypeCode ===
                      _unref(ALARM_MODE_TYPE).DURING_NUM
                    )
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 2,
                                      "label-width": "5",
                                      prop: 'sensors.' + index + '.conditionDuring',
                                      rules: [
                      {
                        required: true,
                        message: _ctx.$t('W_TACTICS.selectMsg'),
                        trigger: 'change',
                      },
                    ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input_number, {
                                          placeholder: _ctx.$t('W_TACTICS.count'),
                                          modelValue: domain.conditionDuring,
                                          "onUpdate:modelValue": ($event: any) => ((domain.conditionDuring) = $event),
                                          "controls-position": "right",
                                          precision: 0,
                                          min: 1,
                                          style: {"width":"90px"}
                                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (reduce('sensors', index)),
                                  class: "icon-delete"
                                }, null, 8, _hoisted_7)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ]),
                      _: 1
                    }),
                    (_unref(showIncrease))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "ws_mt5",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (increase('sensors'))),
                          type: "text"
                        }, {
                          icon: _withCtx(() => [
                            _hoisted_8
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('W_TACTICS.add')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (form.value.triggerTypeCode === _unref(WARNING_TYPE_ENUM).SENSORINCRE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('W_TACTICS.triggerCondition'),
                      prop: "conditionCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.conditionCode,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.conditionCode) = $event)),
                          class: "ws_select_form",
                          style: {"width":"345px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: _unref(ALARM_SATISFY_TYPE).SATISFY_ALL,
                              label: _ctx.$t('W_TACTICS.conditionAll')
                            }, null, 8, ["value", "label"]),
                            _createVNode(_component_el_option, {
                              value: _unref(ALARM_SATISFY_TYPE).SATISFY_ONE,
                              label: _ctx.$t('W_TACTICS.conditionOne')
                            }, null, 8, ["value", "label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          class: "sensors-form-item",
                          prop: "sensors",
                          "label-width": 1,
                          rules: [
                  {
                    required: true,
                    message: _ctx.$t('W_TACTICS.sensorsMsg'),
                    trigger: 'change',
                    type: 'array',
                  },
                ]
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.sensors, (domain, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "bg",
                                key: index
                              }, [
                                _createVNode(_component_el_form_item, {
                                  prop: 'sensors.' + index + '.deviceId',
                                  "label-width": 1
                                }, {
                                  default: _withCtx(() => [
                                    (!isLora(form.value.deviceId))
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          "label-width": "5",
                                          prop: 'sensors.' + index + '.subDeviceId',
                                          rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.selectMsg'),
                          trigger: 'change',
                        },
                      ]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: domain.subDeviceId,
                                              "onUpdate:modelValue": ($event: any) => ((domain.subDeviceId) = $event),
                                              class: "select_item",
                                              placeholder: _ctx.$t('W_TACTICS.subDevicePla'),
                                              onChange: 
                          (e) => onDeviceChildrenChange('sensors', e, index)
                        
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDiviceChildren(form.value.deviceId), (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.value,
                                                    label: item.label,
                                                    value: item.value
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop", "rules"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "5",
                                      prop: 'sensors.' + index + '.sensorAttrCode',
                                      rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.selectMsg'),
                          trigger: 'change',
                        },
                      ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: domain.sensorAttrCode,
                                          "onUpdate:modelValue": ($event: any) => ((domain.sensorAttrCode) = $event),
                                          class: "select_item",
                                          placeholder: _ctx.$t('W_TACTICS.varPla')
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVarList(
                            isLora(form.value.deviceId)
                              ? form.value.deviceId
                              : domain.subDeviceId
                          ), (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "5",
                                      prop: 'sensors.' + index + '.operatorTypeCode',
                                      rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.selectMsg'),
                          trigger: 'change',
                        },
                      ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: domain.operatorTypeCode,
                                          "onUpdate:modelValue": ($event: any) => ((domain.operatorTypeCode) = $event),
                                          class: "select_item",
                                          placeholder: _ctx.$t('W_TACTICS.range')
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(operatorList, (item) => {
                                              return _createVNode(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"])
                                            }), 64))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "5",
                                      prop: 'sensors.' + index + '.thresholdStart',
                                      class: "operation-form",
                                      rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                        },
                        {
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                          type: 'number',
                        },
                      ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(getOperator(domain.operatorTypeCode, 'unit')), 1),
                                        _createVNode(_component_el_input_number, {
                                          style: {"width":"120px"},
                                          class: "select_value input-number",
                                          modelValue: domain.thresholdStart,
                                          "onUpdate:modelValue": ($event: any) => ((domain.thresholdStart) = $event),
                                          placeholder: _ctx.$t('W_TACTICS.changeValuePla'),
                                          precision: 2,
                                          controls: false
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(getUnit(
                          isLora(form.value.deviceId)
                            ? form.value.deviceId
                            : domain.subDeviceId,
                          domain.sensorAttrCode
                        )), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    (showSecondThreshold(domain.operatorTypeCode))
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 1,
                                          "label-width": "5",
                                          prop: 'sensors.' + index + '.thresholdEnd',
                                          class: "operation-form",
                                          rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                        },
                        {
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                          type: 'number',
                        },
                      ]
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_13, _toDisplayString(getOperator(domain.operatorTypeCode, 'unit2')), 1),
                                            _createVNode(_component_el_input_number, {
                                              style: {"width":"120px"},
                                              class: "select_value input-number",
                                              modelValue: domain.thresholdEnd,
                                              "onUpdate:modelValue": ($event: any) => ((domain.thresholdEnd) = $event),
                                              modelModifiers: { number: true },
                                              placeholder: _ctx.$t('W_TACTICS.changeValuePla'),
                                              precision: 2,
                                              controls: false
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(getUnit(
                          isLora(form.value.deviceId)
                            ? form.value.deviceId
                            : domain.subDeviceId,
                          domain.sensorAttrCode
                        )), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["prop", "rules"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["prop"]),
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (reduce('sensors', index)),
                                  class: "icon-delete"
                                }, null, 8, _hoisted_15)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ]),
                      _: 1
                    }),
                    (_unref(showIncrease))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "ws_mt5",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (increase('sensors'))),
                          type: "text"
                        }, {
                          icon: _withCtx(() => [
                            _hoisted_16
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('W_TACTICS.add')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('W_TACTICS.alarmConditions'),
                      prop: "conditionCode2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.conditionCode2,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.conditionCode2) = $event)),
                          class: "ws_select_form",
                          style: {"width":"345px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: _unref(ALARM_SATISFY_TYPE).SATISFY_ALL,
                              label: _ctx.$t('W_TACTICS.conditionAll')
                            }, null, 8, ["value", "label"]),
                            _createVNode(_component_el_option, {
                              value: _unref(ALARM_SATISFY_TYPE).SATISFY_ONE,
                              label: _ctx.$t('W_TACTICS.conditionOne')
                            }, null, 8, ["value", "label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          class: "sensors-form-item",
                          prop: "sensors2",
                          "label-width": 1,
                          rules: [
                  {
                    required: true,
                    message: _ctx.$t('W_TACTICS.sensorsMsg'),
                    trigger: 'change',
                    type: 'array',
                  },
                ]
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.sensors2, (domain, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "bg",
                                key: index
                              }, [
                                _createVNode(_component_el_form_item, {
                                  prop: 'sensors2.' + index + '.deviceId',
                                  "label-width": 1
                                }, {
                                  default: _withCtx(() => [
                                    (!isLora(form.value.deviceId))
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          "label-width": "5",
                                          prop: 'sensors2.' + index + '.subDeviceId',
                                          rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.selectMsg'),
                          trigger: 'change',
                        },
                      ]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: domain.subDeviceId,
                                              "onUpdate:modelValue": ($event: any) => ((domain.subDeviceId) = $event),
                                              class: "select_item",
                                              placeholder: _ctx.$t('W_TACTICS.subDevicePla'),
                                              onChange: 
                          (e) => onDeviceChildrenChange('sensors2', e, index)
                        
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDiviceChildren(form.value.deviceId), (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.value,
                                                    label: item.label,
                                                    value: item.value
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop", "rules"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "5",
                                      prop: 'sensors2.' + index + '.sensorAttrCode',
                                      rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.selectMsg'),
                          trigger: 'change',
                        },
                      ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: domain.sensorAttrCode,
                                          "onUpdate:modelValue": ($event: any) => ((domain.sensorAttrCode) = $event),
                                          class: "select_item",
                                          placeholder: _ctx.$t('W_TACTICS.varPla')
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVarList(
                            isLora(form.value.deviceId)
                              ? form.value.deviceId
                              : domain.subDeviceId
                          ), (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('W_TACTICS.changeValue')), 1),
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "5",
                                      prop: 'sensors2.' + index + '.operatorTypeCode',
                                      rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.selectMsg'),
                          trigger: 'change',
                        },
                      ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: domain.operatorTypeCode,
                                          "onUpdate:modelValue": ($event: any) => ((domain.operatorTypeCode) = $event),
                                          class: "select_item",
                                          placeholder: _ctx.$t('W_TACTICS.range')
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(operatorList, (item) => {
                                              return _createVNode(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"])
                                            }), 64))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "5",
                                      prop: 'sensors2.' + index + '.thresholdStart',
                                      class: "operation-form",
                                      rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                        },
                        {
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                          type: 'number',
                        },
                      ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(getOperator(domain.operatorTypeCode, 'unit')), 1),
                                        _createVNode(_component_el_input_number, {
                                          style: {"width":"120px"},
                                          class: "select_value input-number",
                                          modelValue: domain.thresholdStart,
                                          "onUpdate:modelValue": ($event: any) => ((domain.thresholdStart) = $event),
                                          placeholder: _ctx.$t('W_TACTICS.changeValuePla'),
                                          precision: 2,
                                          controls: false
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                        _createElementVNode("span", _hoisted_20, _toDisplayString(getUnit(
                          isLora(form.value.deviceId)
                            ? form.value.deviceId
                            : domain.subDeviceId,
                          domain.sensorAttrCode
                        )), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    (showSecondThreshold(domain.operatorTypeCode))
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 1,
                                          "label-width": "5",
                                          prop: 'sensors2.' + index + '.thresholdEnd',
                                          class: "operation-form",
                                          rules: [
                        {
                          required: true,
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                        },
                        {
                          message: _ctx.$t('W_TACTICS.enterMsg'),
                          trigger: 'change',
                          type: 'number',
                        },
                      ]
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_21, _toDisplayString(getOperator(domain.operatorTypeCode, 'unit2')), 1),
                                            _createVNode(_component_el_input_number, {
                                              style: {"width":"120px"},
                                              class: "select_value input-number",
                                              modelValue: domain.thresholdEnd,
                                              "onUpdate:modelValue": ($event: any) => ((domain.thresholdEnd) = $event),
                                              modelModifiers: { number: true },
                                              placeholder: _ctx.$t('W_TACTICS.changeValuePla'),
                                              precision: 2,
                                              controls: false
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                            _createElementVNode("span", _hoisted_22, _toDisplayString(getUnit(
                          isLora(form.value.deviceId)
                            ? form.value.deviceId
                            : domain.subDeviceId,
                          domain.sensorAttrCode
                        )), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["prop", "rules"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["prop"]),
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (reduce('sensors2', index)),
                                  class: "icon-delete"
                                }, null, 8, _hoisted_23)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ]),
                      _: 1
                    }),
                    (_unref(showIncrease))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "ws_mt5",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (increase('sensors2'))),
                          type: "text"
                        }, {
                          icon: _withCtx(() => [
                            _hoisted_24
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('W_TACTICS.add')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('W_TACTICS.alarmLevel'),
              prop: "alarmLevelCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.value.alarmLevelCode,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.alarmLevelCode) = $event)),
                  class: "ws_select",
                  clearable: "",
                  style: {"width":"355px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(levelOps, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [_directive_loading, loading.value]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title"])
  ]))
}
}

})